import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';

@Pipe({
  name: 'alaDateTransform',
  standalone: true,
})
export class DateTransform implements PipeTransform {
  public transform(value: Date, formatStr = 'll'): string {
    dayjs.extend(localizedFormat);
    return value ? dayjs(value).format(formatStr) : '';
  }
}
